import * as React from "react";
const SvgFarm = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M5.5 2A3.5 3.5 0 0 0 2 5.5v14.75c0 .966.784 1.75 1.75 1.75h15.5A1.75 1.75 0 0 0 21 20.25v-8.293a.75.75 0 0 0 .61-1.365l-8.25-4.5a.75.75 0 0 0-.719 0L9 8.078V5.5A3.5 3.5 0 0 0 5.5 2Zm12 18.5v-7.75a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v7.75h-2v-9.35L13 7.604l6.5 3.546v9.1a.25.25 0 0 1-.25.25H17.5ZM10 19.316v-4.632L12.008 17 10 19.316Zm3-3.461L10.96 13.5h4.08L13 15.855Zm0 2.29 2.04 2.355h-4.08L13 18.145ZM13.992 17 16 14.684v4.632L13.992 17ZM5 20.5H3.75a.25.25 0 0 1-.25-.25V5.5a2 2 0 1 1 4 0v3.396l-3.109 1.696A.75.75 0 0 0 5 11.957V20.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgFarm;
